module.exports = __webpack_public_path__ + "img/72.3.TP.f2ef32f4.png";